"use client";

import { useState } from "react";
interface BFLHoverBackdropProps {
  children: React.ReactNode;
  headerHeight?: number;
  backdropColor?: string;
  backdropOpacity?: number;
  zIndex?: number;
}
const BFLHoverBackdrop: React.FC<BFLHoverBackdropProps> = ({
  children,
  headerHeight = 80,
  backdropColor = "bg-[#000000b3]",
  backdropOpacity = 50,
  zIndex = 50,
}) => {
  const [showBackdrop, setShowBackdrop] = useState(false);
  const handleMouseEnter = () => setShowBackdrop(true);
  const handleMouseLeave = () => setShowBackdrop(false);
  return (
    <>
      {showBackdrop && (
        <div
          className={`fixed bottom-0 left-0 right-0 ${backdropColor} opacity-${backdropOpacity} pointer-events-none transition-opacity duration-300`}
          style={{ top: `${headerHeight}px`, zIndex }}
          data-testid="bfl-backdrop"
        />
      )}
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
    </>
  );
};
export default BFLHoverBackdrop;
